var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCable({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.25 5H3.75V12.5H16.25V5Z",
    fill: "#8B909A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.8125 2.5C1.94917 2.5 1.25 3.2 1.25 4.0625V13.4375C1.25 14.3 1.95 15 2.8125 15H8.125V16.25H5C4.83424 16.25 4.67527 16.3158 4.55806 16.4331C4.44085 16.5503 4.375 16.7092 4.375 16.875C4.375 17.0408 4.44085 17.1997 4.55806 17.3169C4.67527 17.4342 4.83424 17.5 5 17.5H15C15.1658 17.5 15.3247 17.4342 15.4419 17.3169C15.5592 17.1997 15.625 17.0408 15.625 16.875C15.625 16.7092 15.5592 16.5503 15.4419 16.4331C15.3247 16.3158 15.1658 16.25 15 16.25H11.875V15H17.1875C18.05 15 18.75 14.3 18.75 13.4375V4.0625C18.75 3.19917 18.05 2.5 17.1875 2.5H2.8125ZM2.8125 13.75H17.1875C17.2704 13.75 17.3499 13.7171 17.4085 13.6585C17.4671 13.5999 17.5 13.5204 17.5 13.4375V4.0625C17.5 3.97962 17.4671 3.90013 17.4085 3.84153C17.3499 3.78292 17.2704 3.75 17.1875 3.75H2.8125C2.72962 3.75 2.65013 3.78292 2.59153 3.84153C2.53292 3.90013 2.5 3.97962 2.5 4.0625V13.4375C2.5 13.61 2.64 13.75 2.8125 13.75Z",
    fill: "#8B909A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCable);
export default __webpack_public_path__ + "static/media/Cable.958945105e3d6f170b8f68d974db4934.svg";
export { ForwardRef as ReactComponent };